import { Grid, withWidth, Typography } from "@material-ui/core";
import React, { useEffect } from "react";
import { GetAdminEmail } from "../../../../../const";

function Contact(props) {

    const [adminEmail, setAdminEmail] = React.useState("");
    const year = new Date().getFullYear();

    useEffect(() => {
        GetAdminEmail().then(res => {
            setAdminEmail(res.data.data.email);
        })
    }, []);


    return (
        <React.Fragment>
            <div style={{ backgroundColor: "#19273e", position: "relative", padding: props.cookiesState ? "20px 70px 20px 70px" : props.width === 'xs' ? "20px 70px 285px 70px" : props.width === 'sm' ? "20px 70px 200px 70px" : "20px 70px 150px 70px" }} ref={props.contactRef}>
                {/*  <Grid container direction="row" alignItems="end" justifyContent="flex-end" >
                    <Grid item xs={12} sm={12} md={5} />
                    <Grid item xs={12} sm={12} md={5} >
                        <Grid container direction="row" alignItems="end" justifyContent={props.width === 'xs' || props.width === 'sm' ? "center" : "flex-end"} >
                            <Grid item xs={3} sm={3} md={3} >
                                <Typography style={{ fontSize: 10, color: "#fff" }}>EXPLORE</Typography>
                                <Stack verticalAlign style={{ marginTop: 20 }} tokens={{ childrenGap: 10 }}>
                                    <Typography style={{ fontSize: 10, color: "#fff" }}>Solutions</Typography>
                                    <Typography style={{ fontSize: 10, color: "#fff" }}><a href={`mailto:${adminEmail}`} style={{ textDecoration: "none", color: "#fff" }}>Support</a></Typography>
                                </Stack>
                            </Grid>
                            <Grid item xs={3} sm={3} md={3} >
                                <Typography style={{ fontSize: 10, color: "#fff" }}>COMPANY</Typography>
                                <Stack verticalAlign style={{ marginTop: 20 }} tokens={{ childrenGap: 10 }}>
                                    <Typography style={{ fontSize: 10, color: "#fff" }}>About</Typography>
                                    <Typography style={{ fontSize: 10, color: "#fff" }}>Contact</Typography>
                                </Stack>
                            </Grid>
                            <Grid item xs={3} sm={3} md={3} >
                                <Typography style={{ fontSize: 10, color: "#fff" }}>SOCIALS</Typography>
                            </Grid>
                        </Grid>
                        
                    </Grid>
                    <Grid item xs={12} sm={12} />
                    <Grid item xs={12} sm={12} md={12} style={{marginTop: 10}}>
                        <Grid container direction="row" >
                            <Grid item xs={12} sm={12} md={6} style={{ textAlign: props.width === 'xs' || props.width === 'sm' ? "center" : "left" }}>
                        <Typography style={{ fontSize: 10, color: "#fff" }}>  © 2022  <a href={"https://terawe.com"} style={{ textDecoration: "none", color: "#fff" }} target="_blank" rel="noopener noreferrer">Terawe Corp.</a> All Rights Reserved. | <a href={`mailto:${adminEmail}`} style={{ textDecoration: "none", color: "#fff" }}>{adminEmail}</a></Typography>
                    </Grid>
                            <Grid item xs={12} sm={12} md={6} style={{ textAlign: props.width === 'xs' || props.width === 'sm' ? "center" : "right"  }} >
                                <Typography style={{ fontSize: 10, color: "#fff" }}> <a href={"https://www.terawe.com/Terms-Of-Use"} style={{ textDecoration: "none", color: "#fff" }} target="_blank" rel="noopener noreferrer">Terms of use</a> | <a href={"https://www.terawe.com/Privacy-Policy"} style={{ textDecoration: "none", color: "#fff" }} target="_blank" rel="noopener noreferrer">Privacy Policy</a></Typography>
                        </Grid>
                    </Grid>
                    </Grid>
                </Grid>*/}
                <Grid container direction="row">
                    {/*<Grid item xs={12} sm={12} style={{ margin: "20px 0px 20px 0px" }} >
                        <Typography style={{ fontSize: 12, color: "#fff" }}>
                            This site is jointly operated by Microsoft and Terawe, and both companies are committed to protecting your privacy. Any personal information we collect from you on this site may be shared between Microsoft and Terawe. For complete information on the data collection and use practices of each company, please read the full privacy statements by clicking on the links below.
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} style={{ margin: "0px 0px 10px 0px" }} >
                        <div style={{ marginTop: 10, height: 0.8, backgroundColor: "#fff" }}></div>
                    </Grid>*/}
                    <Grid item xs={12} sm={12} md={12} style={{ marginTop: 10 }}>
                        <Grid container direction="row" >
                            <Grid item xs={12} sm={12} md={6} style={{ textAlign: props.width === 'xs' || props.width === 'sm' ? "center" : "left" }}>
                                <Typography style={{ fontSize: 12, color: "#fff" }}>  © {year}  <a href={"https://terawe.com"} style={{ textDecoration: "none", color: "#fff" }} target="_blank" rel="noopener noreferrer">Terawe Corp.</a> All Rights Reserved. | <a href={`mailto:research@terawe.com`} style={{ textDecoration: "none", color: "#fff" }}>research@terawe.com</a></Typography>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} style={{ textAlign: props.width === 'xs' || props.width === 'sm' ? "center" : "right" }} >
                                <Typography style={{ fontSize: 12, color: "#fff" }}> <a href={"https://www.terawe.com/Terms-Of-Use"} style={{ textDecoration: "none", color: "#fff" }} target="_blank" rel="noopener noreferrer">Terms of use</a> | <a href={"https://www.terawe.com/Privacy-Policy"} style={{ textDecoration: "none", color: "#fff" }} target="_blank" rel="noopener noreferrer"> Privacy Policy</a></Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </div>

        </React.Fragment>
    );
}

export default withWidth()(Contact);